// ════════════════════════════════════════════════════════════════════════════
// BOT DECK REGISTRY
// Every bot opponent's deck list + behavior lives in its own file under
// js/bot_logic/decks/, registered here by calling registerBotDeck(id, def)
// at parse time (same "registry loads first, per-item files call register*()"
// convention as js/effects/registry.js + js/effects/{color}.js). game.js and
// js/bot_logic/bot-engine.js both read window.BotDecks directly by id — this
// file has no other responsibility.
//
// def shape (see js/bot_logic/bot-engine.js's header comment for the full
// contract each hook must satisfy):
//   id                 — must match the key passed to registerBotDeck
//   name               — display name shown on the deck-select card
//   representativeCard — cardNo shown behind the deckbox art on the select card
//   decklist           — { cardNo: copies, ... }, exactly 50 copies total
//   sideboard          — { cardNo: copies, ... }, may be {}
//   shouldMulligan, chooseNextDeployOrActivate, onDeploy, onDeployBase,
//   onActivateBase, onActivateCommand, onPair, onDestroyed, onBurst,
//   onLinkedUnitDestroysEnemy, chooseAttackOrder, chooseAttackTarget,
//   shouldBlock, chooseBlockTarget, resolvePick, chooseActionStepPlay
// ════════════════════════════════════════════════════════════════════════════
window.BotDecks = {};

function registerBotDeck(id, def) {
  window.BotDecks[id] = Object.assign({ id }, def);
}
